import { SettingService } from './../../domain/setting/services/setting.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PublicSettingService extends SettingService {
  protected settingResolverEndpoint = '/setting/tenant';
}
